import AddGroupContainer from "./AddGroupContainer";

const AddGroup = AddGroupContainer;

export default AddGroup;
